import {
  DollarSign,
  IndianRupee,
  PoundSterling,
  Euro,
  JapaneseYen,
  Banknote,
  type LucideProps,
} from 'lucide-react';
import { useCurrency } from '../hooks/useCurrency';

/**
 * Currency icon that reflects the active company's currency instead of a
 * hardcoded $ (DollarSign) or ₹ (IndianRupee). Drop-in replacement: accepts the
 * same props as any lucide icon (className, size, color, strokeWidth, …).
 *
 * Falls back to a generic banknote glyph for currencies lucide has no icon for.
 */
export function CurrencyIcon(props: LucideProps) {
  const { code } = useCurrency();

  switch (code) {
    case 'INR':
    case 'LKR':
    case 'NPR':
    case 'PKR':
      return <IndianRupee {...props} />;
    case 'GBP':
      return <PoundSterling {...props} />;
    case 'EUR':
      return <Euro {...props} />;
    case 'JPY':
    case 'CNY':
      return <JapaneseYen {...props} />;
    case 'USD':
    case 'AUD':
    case 'SGD':
    case 'MXN':
    case 'BRL':
      return <DollarSign {...props} />;
    default:
      return <Banknote {...props} />;
  }
}

export default CurrencyIcon;
